import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <div className="brunson-card rounded-xl p-5 md:p-7 text-center" data-id="element-84">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-brand-green rounded-full border-4 border-brand-navy mb-3" data-id="element-85">
            <ShieldCheck className="w-10 h-10 text-white" data-id="element-86" />
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy uppercase leading-tight mb-2" data-id="element-87">
            🛡️ Garantía 7 Días
          </h2>
          <p className="font-display font-bold text-brand-orange uppercase text-sm md:text-base tracking-widest mb-3" data-id="element-88">
            Sin Preguntas · Sin Formularios · Sin Vueltas
          </p>
          <p className="text-sm md:text-base text-brand-ink font-medium leading-snug mb-2" data-id="element-89">
            Usá el sistema en tu aula. Dictá una unidad completa, usá las
            planillas, aplicá las actividades.
          </p>
          <p className="text-sm md:text-base text-brand-ink font-medium leading-snug mb-3" data-id="element-90">
            Si en 7 días no sentís que tus clases mejoraron y que recuperaste
            tiempo real, escribinos con tu comprobante y te devolvemos el{' '}
            <span className="font-bold text-brand-green" data-id="element-91">
              100% de tu dinero
            </span>
            . Sin formularios. Sin tiempo de espera. Sin excusas.
          </p>
          <div className="bg-brand-greenSoft border-2 border-brand-green rounded-lg p-3 inline-block" data-id="element-92">
            <p className="text-xs md:text-sm font-bold text-brand-navy uppercase tracking-wide" data-id="element-93">
              Tasa de devoluciones:{' '}
              <span className="text-brand-green" data-id="element-94">menos del 2%</span>
            </p>
            <p className="text-xs text-brand-mute italic font-medium" data-id="element-95">
              Porque el docente que lo usa, no lo devuelve.
            </p>
          </div>
        </div>
      </div>
    </section>;
}